import React from 'react'
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../../../hooks/useStore';
import { withPrefix } from 'gatsby';


const ShareCityListUI = () => {
    return (
        <div className='city-list-ui flex--center'>
            <ActiveCityTab/>
            <CitiesList/>
            <style jsx>{`
                .city-list-ui {
                    padding-bottom: 20px;
                    // position: absolute;
                    // top: 0px;
                    // left: 320px;
                    // background: white;
                    // border-radius: 8px;
                    // overflow: hidden;
                    // cursor: pointer;
                    // width: 142px;

                }
            `}</style>
        </div>
    )
}

const ActiveCityTab = observer(() => {
    const {uiStore: {home__share__activeCity, resetActiveShareCity}, cursorStore: {handleMouseEnter, handleMouseLeave}} = useStore()
    if (!home__share__activeCity) return null
    
    return (
        <div
            onClick={() => {
                resetActiveShareCity()
                handleMouseLeave()
            }}
            onMouseEnter={() => handleMouseEnter("action", "Back to all cities")}
            onMouseLeave={handleMouseLeave}
        >
            <h6 className='text-s'>
                {home__share__activeCity}
            </h6>
            <img className='close' src={withPrefix('/images/modal-close-btn.svg')} alt=""    /> 

            <style jsx>{`
                div {
                    padding: 8px 24px;
                    background: white;
                    border-radius: 8px;
                    padding-right: 40px;
                    position: relative;
                    transition: background 0.2s;
                }

                div:hover {
                    background: #eaeaea;
                }

                img {
                    width: 24px;
                    position: absolute;
                    top: 2px;
                    right: 6px;
                }

                .close {
                    top: 6px;
                    pointer-events: none;
                }
            `}</style>
        </div>
    )
})


const CitiesList = observer(() => {
    const {uiStore: {home__share__activeCity, updateActiveShareCity}, cursorStore: {handleMouseEnter, handleMouseLeave}} = useStore();
    if (home__share__activeCity) return null;

    const cities = [
        // "All cities",
        "Atlanta",
        "Buffalo",
        "Chicago",
        "Detroit",
        "LA",
        "Philadelphia"
    ];

    return (
        <div>
            {cities.map(city => {
                // if (home__map__activeCity === city) return null
                return <City 
                            key={`msm-${city}`}
                            data={city} 
                            onClick={
                            () => {
                                updateActiveShareCity(city)
                                handleMouseLeave()
                            }}
                            onMouseEnter={() => {
                                handleMouseEnter("action", `View ${city} Orgs`);
                            }}
                            onMouseLeave={() => {
                                handleMouseLeave();
                            }}
                        />
            })}

            <style jsx>{`
                div {
                    width: 320px;
                }
            `}</style>
        </div>
    )
});

const City = ({data, onClick = null, onMouseEnter = null, onMouseLeave = null}) => {
    return (
        <div 
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <h3 className=''>
                {data}
            </h3>
            <style jsx>{`
                div {
                    margin: 16px 0;
                    cursor: pointer;
                    text-align: center;
                }
                div:hover h3{
                    background: #bbb;
                }               
                h3 {
                    width: 100%;
                    user-select: none;
                    text-align: center;
                    padding: 8px 24px;
                    text-align: center;
                    // width: 90%;
                    margin: 0 auto;
                    transition: background 0.2s;
                    border-radius: 100px;
                    font-size: 40px;
                }

                

                @media (max-width: 769px), (pointer: coarse) {
                    div {
                        padding: 12px 30px;
                    }
                }
            `}</style>
        </div>
    )
}

export default ShareCityListUI   